import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Sidebar';
import { useLanguage } from '../../contexts/LanguageContext';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Plus, Download } from 'lucide-react';
import { downloadPdf } from '../../utils/downloadPdf';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PortalQuotes() {
  const { t } = useLanguage();
  const [quotes, setQuotes] = useState<any[]>([]);

  useEffect(() => {
    axios.get(`${API}/api/quotes`, { withCredentials: true }).then(r => setQuotes(r.data)).catch(() => {});
  }, []);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar type="portal" active="quotes" />
      <main data-testid="portal-quotes-page" style={{ flex: 1, background: 'var(--bg-portal)', padding: 32 }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
            <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 28, fontWeight: 700 }}>{t('portal.quotes')}</h1>
            <Link to="/services" data-testid="portal-new-quote-link" style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              background: 'var(--primary)', color: 'white', padding: '10px 20px',
              fontWeight: 600, fontSize: 14, textTransform: 'uppercase',
            }}><Plus size={16} /> {t('portal.new_quote')}</Link>
          </div>

          <div style={{ background: 'white', border: '1px solid var(--border)' }}>
            {quotes.length === 0 ? (
              <div style={{ padding: 48, textAlign: 'center', color: 'var(--text-muted)' }}>{t('portal.no_quotes')}</div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid var(--border)' }}>
                      {[t('quote.category'), t('quote.product'), t('quote.quantity'), t('portal.status'), t('portal.date'), 'PDF'].map(h => (
                        <th key={h} style={{ padding: '12px 20px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {quotes.map((q: any) => (
                      <tr key={q._id} style={{ borderBottom: '1px solid var(--border)' }}>
                        <td style={{ padding: '14px 20px', fontSize: 14 }}>{q.product_category}</td>
                        <td style={{ padding: '14px 20px', fontSize: 14, fontWeight: 500 }}>{q.product_name}</td>
                        <td style={{ padding: '14px 20px', fontSize: 14 }}>{q.quantity}</td>
                        <td style={{ padding: '14px 20px' }}>
                          <span style={{ padding: '4px 10px', fontSize: 12, fontWeight: 600, background: q.status === 'approved' ? 'rgba(34,197,94,0.12)' : q.status === 'rejected' ? 'rgba(239,68,68,0.12)' : 'rgba(251,191,36,0.12)', color: q.status === 'approved' ? '#16A34A' : q.status === 'rejected' ? '#DC2626' : '#D97706', textTransform: 'uppercase' }}>
                            {t(`status.${q.status}`)}
                          </span>
                        </td>
                        <td style={{ padding: '14px 20px', fontSize: 13, color: 'var(--text-muted)' }}>{new Date(q.created_at).toLocaleDateString()}</td>
                        <td style={{ padding: '14px 20px' }}>
                          <button onClick={() => downloadPdf(`/api/quotes/${q._id}/pdf`, `quote-${q._id.slice(-8)}.pdf`)} data-testid={`quote-pdf-${q._id}`}
                            style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', fontSize: 11, fontWeight: 600, background: 'rgba(13,71,161,0.08)', color: 'var(--primary)', border: '1px solid rgba(13,71,161,0.2)', cursor: 'pointer' }}>
                            <Download size={12} /> PDF
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
